import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postSuperlike,
  type PostSuperlikeParams,
  type PostSuperlikeResponse,
} from '@services/SuperlikesService';

export type UsePostSuperlikeParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostSuperlikeResponse,
    unknown,
    string,
    PostSuperlikeParams,
    PostSuperlikeResponse
  >;
};

export const postSuperlikeMutationKey = 'post-superlike';

export const usePostSuperlike = ({
  mutationOptions,
}: UsePostSuperlikeParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostSuperlikeResponse,
    unknown,
    string,
    PostSuperlikeParams
  >(
    postSuperlikeMutationKey,
    (_url, { arg }) => postSuperlike(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
